import { r as createLogger } from "./logger-CdXeOlrX.js";
//#region ../src/ar/qr/detection-scheduler.ts
const log = createLogger("DetectionScheduler");
const defaultNow = () => typeof performance !== "undefined" && typeof performance.now === "function" ? performance.now() : Date.now();
function createDetectionScheduler(config) {
	const { detect, minIntervalMs, requiredLockCount = 3, now = defaultNow, onLocked, onMiss, onError } = config;
	let inFlight = false;
	let disposed = false;
	let consecutiveLocks = 0;
	let lastStart = -Infinity;
	return {
		get inFlight() {
			return inFlight;
		},
		get consecutiveLocks() {
			return consecutiveLocks;
		},
		get locked() {
			return consecutiveLocks >= requiredLockCount;
		},
		dispose() {
			disposed = true;
		},
		offerFrame(image) {
			if (disposed) return;
			if (inFlight) return;
			const t = now();
			if (t - lastStart < minIntervalMs) return;
			lastStart = t;
			inFlight = true;
			(async () => detect(image))().then((result) => {
				if (disposed) return;
				if (result) {
					consecutiveLocks = Math.min(consecutiveLocks + 1, requiredLockCount);
					if (consecutiveLocks >= requiredLockCount) try {
						onLocked?.(result);
					} catch (err) {
						log.error("onLocked callback threw:", err);
					}
				} else {
					consecutiveLocks = 0;
					try {
						onMiss?.();
					} catch (err) {
						log.error("onMiss callback threw:", err);
					}
				}
			}).catch((err) => {
				consecutiveLocks = 0;
				if (disposed) return;
				try {
					onError?.(err);
				} catch (callbackErr) {
					log.error("onError callback threw:", callbackErr);
				}
			}).finally(() => {
				inFlight = false;
			});
		}
	};
}
//#endregion
export { createDetectionScheduler as t };
